import { render, staticRenderFns } from "./AdminPush.vue?vue&type=template&id=0aa558ee"
import script from "./AdminPush.vue?vue&type=script&lang=js"
export * from "./AdminPush.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports